import { DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useSubscription } from "@/hooks/billing/useSubscription";

export function PanelHeader({ orgId }: { orgId?: string }) {
  // While the query is pending we fall back to the "choose your
  // plan" framing — the SR-only title isn't visible mid-flight, so
  // the user never sees a flash of either label.
  const { data } = useSubscription(orgId);
  const hasActiveSubscription = data?.hasActiveSubscription ?? false;

  return (
    <DialogHeader>
      <DialogTitle className="sr-only">
        {hasActiveSubscription ? "Your plan" : "Choose your plan"}
      </DialogTitle>
    </DialogHeader>
  );
}
